import railsData from 'utilities/rails-data';
import {GoogleAnalyticsEventType} from './constants';

interface PayloadObject {
  eventCategory?: string;
  eventAction?: string;
  eventValue?: string;
  eventLabel?: string;
}

type Payload = PayloadObject | string;

function sendGoogleAnalytics({
  type,
  payload,
}: {
  type: GoogleAnalyticsEventType;
  payload: Payload;
}) {
  if (!isGoogleAnalyticsDefined()) return;

  ga('send', type, payload);
}

function initGoogleAnalytics(id: string) {
  if (!isGoogleAnalyticsDefined()) return;

  ga('create', id, 'auto');
}

function isGoogleAnalyticsDefined(): boolean {
  return railsData('env') === 'production' && typeof ga !== 'undefined';
}

export {sendGoogleAnalytics, initGoogleAnalytics, Payload, PayloadObject};
